module.exports = {
    title: {
        en: "Enfield Town",
        cy: "Ymgynghoriad sefydlog",
    },

    description: {
        en: "Residential-led regeneration proposals for a brownfield site at 29 Southbury Road, Enfield EN1 1YZ Comprehensive are currently at draft design stage.",
        cy: "Welsh Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas mattis tempus est, vel ornare mi posuere in."
    },

    socialImage: "/assets/images/logos/regenta.png",

    company: {
        address: "Eagle Tower, Montpellier Dr, Cheltenham GL50 1TA",
        phoneNumber: "01234567890",
        number: "019283746",
    },

    email: "contact@enfieldtown.info"
}